<template>
  <div>
    <div class="cont-selector">
      <div class="filter-item vertical-align-middle player-team" v-if="hasPlayerNationalTeam && hasPlayerClubSeasons">
        <span @click="setIsPlayerNationalTeam(false)" class="is-clickable" style="margin-right: 12px;">CLUB</span>
        <BSwitch :value="isPlayerNationalTeam" passive-type="is-primary" @input="setIsPlayerNationalTeam" />
        <span class="is-clickable" @click="setIsPlayerNationalTeam(true)">SELECCIÓN NACIONAL</span>
      </div>
      <div class="cont-selector__div-Selector"></div>
      <div class="cont-selector__cont-select-tournament">
        <div>
          <div class="cont-selector__cont-select-tournament__label">
            Torneo:
          </div>
        </div>
        <div>
          <BField position="is-centered" type="is-info" class="select-statistics">
            <BSelect
              class="is-inline-block vertical-align-middle"
              placeholder="Selecciona uno"
              :value="seasonId"
              @input="onSeasonChanged"
            >
              <option v-for="season in seasons" :key="season.id" :value="season.id">
                {{ season.name }}
              </option>
            </BSelect>
          </BField>
        </div>
      </div>
    </div>

    <div class="cont-summaryVideostrengths ">
      <div class="is-bordered-box-shadow-main summaryVideostrengths first-element">
        <div class="summaryVideostrengths__video">
          <MediaPlayer :is-first-row="isFirstRow" />
        </div>
      </div>
      <div class="is-bordered-box-shadow-main summaryVideostrengths second-element">
        <div class="summaryVideostrengths__strengths"><SummaryStrengths :type="1" :key="update" /></div>
      </div>
    </div>
    <div class="is-bordered-box-shadow-main summaryGenLast">
      <div class="summaryGenLast__general">
        <SummaryGeneral
          :season="seasonName.name"
          :match="dataSeason"
          :type="1"
          :position="player.position_id"
          :key="update"
        />
      </div>
      <div class="summaryGenLast__lastgame">
        <SummaryLastGame
          :game="lastGameInfo"
          :match="lastGame"
          :type="1"
          :position="player.position_id"
          :key="update"
        />
      </div>
    </div>
    <div class="is-bordered-box-shadow-main matchbymatch">
      <MatchByMatch :games="gamesByTeam" :matchs="dataMatchByMatch" :type="1" :player="player" :key="update" />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapState, mapMutations } from 'vuex';
import MatchByMatch from '@/components/Elements/MatchByMatch';
import SummaryGeneral from '@/components/Elements/SummaryGeneral';
import SummaryLastGame from '@/components/Elements/SummaryLastGame';
import SummaryStrengths from '@/components/Elements/SummaryStrengths';
import MediaPlayer from '@/components/Sections/MediaPlayer-v3/Main';

export default {
  name: 'PlayerSummary',
  components: {
    MatchByMatch,
    SummaryGeneral,
    SummaryLastGame,
    SummaryStrengths,
    MediaPlayer,
  },
  data() {
    return {
      dataMatchByMatch: [],
      allGames: [],
      gamesByTeam: [],
      lastGame: [],
      lastGameInfo: [],
      dataSeason: [],
      update: 0,
      seasonName: '',
    };
  },
  watch: {
    // isPlayerNationalTeam() {
    //   this.$store.dispatch('playersGeneral/cleanData');
    //   this.$store.dispatch('playersGeneral/checkStateSummary', {
    //     seasonNumber: Number(this.seasonId),
    //     playerId: Number(this.$route.params.playerId),
    //   });
    // },

    seasons(newValue) {
      let seasonId = 0;
      this.fillDataGeneral();
      if (newValue.find(season => season.id === this.seasonId)) {
        seasonId = this.seasonId;
      } else {
        seasonId = newValue[0].id;
      }
      if (this.summaryData) {
        this.summaryData.seasonId = seasonId;
      }
    },
  },
  computed: {
    ...mapState('filterGeneral', [
      'hasPlayerNationalTeam',
      'isPlayerNationalTeam',
      'nationalSeasons',
      'hasPlayerClubSeasons',
    ]),
    ...mapState({ windowWidth: 'windowWidth' }),
    ...mapState('mediaGeneral', ['summaryData']),
    ...mapState('filterGeneral', ['seasons']),
    ...mapGetters('filterGeneral', {
      seasonId: 'getSeasonId',
    }),
    ...mapGetters('teamsGeneral', { teamId: 'teamId' }),
    ...mapGetters('playersGeneral', { player: 'player', playerTeam: 'teamId' }),
    ...mapGetters('loginGeneral', ['isGoalkeeper']),
    isFirstRow() {
      return this.windowWidth > 1308;
    },
  },
  methods: {
    ...mapMutations('filterGeneral', ['setIsPlayerNationalTeam']),
    async fillDataGeneral() {
      try {
        this.dataSeason = [];
        const urlSendAxios = `https://ikhibrrvce.execute-api.us-east-2.amazonaws.com/prod/details-per-game/seasons/${this.seasonId}/players/${this.$route.params.playerId}`;
        const urlGamesSendAxios = `https://8tvo5bp9ai.execute-api.us-west-2.amazonaws.com/prod/gamesBySeason/${this.seasonId}/`;
        await axios.all([axios.get(urlSendAxios), axios.get(urlGamesSendAxios)]).then(
          axios.spread((data, games) => {
            const gamesWithInformationMap = new Map();
            if (data.data) {
              for (let index = 0; index < data.data.information_by_game.length; index++) {
                const gameWithInfo = data.data.information_by_game[index];
                gamesWithInformationMap.set(gameWithInfo.game_id, { hasStats: gameWithInfo.has_stats });
                this.dataMatchByMatch[gameWithInfo.game_id] = [];
                this.dataMatchByMatch[gameWithInfo.game_id]['game'] = gameWithInfo.game_id;
                this.dataMatchByMatch[gameWithInfo.game_id]['isTitular'] = gameWithInfo.started_as_titular;
                this.dataMatchByMatch[gameWithInfo.game_id]['minutes'] = gameWithInfo.minutes_played;
                this.dataMatchByMatch[gameWithInfo.game_id]['goals'] = gameWithInfo.goals;
                this.dataMatchByMatch[gameWithInfo.game_id]['yellowcards'] = gameWithInfo.yellow_cards;
                this.dataMatchByMatch[gameWithInfo.game_id]['redcards'] = gameWithInfo.red_cards;
                let keyArrayByGame = Object.keys(gameWithInfo.extra_categories[0])[0];
                this.dataMatchByMatch[gameWithInfo.game_id]['extra_categories'] =
                  gameWithInfo.extra_categories[0][keyArrayByGame];
              }
              this.dataSeason['games_as_bench'] = data.data.season_information.games_as_bench;
              this.dataSeason['games_as_titular'] = data.data.season_information.games_as_titular;
              this.dataSeason['goals'] = data.data.season_information.goals;
              this.dataSeason['minutesPlayed'] = data.data.season_information.minutesPlayed;
              this.dataSeason['red_cards'] = data.data.season_information.red_cards;
              this.dataSeason['yellow_cards'] = data.data.season_information.yellow_cards;
              let keyArray = Object.keys(data.data.season_information.extra_categories[0])[0];

              this.dataSeason['extra_categories'] = data.data.season_information.extra_categories[0][keyArray];
            }
            this.gamesByTeam = games.data.games.reduce((accumulator, game) => {
              if (game.home_team === data.data.team_id || game.visiting_team === data.data.team_id) {
                const gameInfo = gamesWithInformationMap.get(game.game_id);
                game.hasStats = gameInfo ? gameInfo.hasStats : null;
                accumulator.push(game);
              }
              return accumulator;
            }, []);
            this.gamesByTeam = this.gamesByTeam.sort((a, b) => (a.date > b.date ? 1 : b.date > a.date ? -1 : 0));
            let idLastGame = 0;
            for (let index = 0; index < this.gamesByTeam.length; index++) {
              if (this.dataMatchByMatch[this.gamesByTeam[index].game_id]) {
                idLastGame = this.dataMatchByMatch[this.gamesByTeam[index].game_id];
              }
            }
            this.lastGame = idLastGame;
            this.lastGameInfo = this.gamesByTeam.find(x => x.game_id === idLastGame['game']);
            this.seasonName = this.seasons.find(
              season => season.id === this.$store.getters['filterGeneral/getSeasonId'],
            );
            this.update += 1;
          }),
        );
      } catch (e) {
        throw new Error(e);
      }
    },
    async onSeasonChanged(value) {
      if (this.$store.getters['filterGeneral/getSeasonId'] !== value) {
        this.$store.commit('filterGeneral/setSeasonId', value);
        const selectedSeason = this.seasons.find(season => season.id === value);
        if (selectedSeason) {
          this.$store.commit('filterGeneral/setSeasonType', selectedSeason.type);
        }
        // this.$store.dispatch('playersGeneral/cleanData');
        // await this.$store.dispatch('playersGeneral/checkStateSummary', {
        //   seasonNumber: Number(value),
        //   playerId: Number(this.$route.params.playerId),
        // });
        // console.log('Hola 6');
        this.fillDataGeneral();
        this.$emit('seasonChanged');
      }
    },
  },
  created() {
    if (this.seasons.length) {
      this.fillDataGeneral();
    }
  },
};
</script>
<style>
.select-statistics select {
  width: 11.24vw;
  height: 1.9vw;
}

@media screen and (max-width: 1700px) {
  .select-statistics select {
    width: 12.24vw;
    height: 2.4vw;
  }
}
@media screen and (max-width: 1350px) {
  .select-statistics select {
    width: 15.24vw;
    height: 3.1vw;
  }
}
@media screen and (max-width: 1100px) {
  .select-statistics select {
    width: 19.24vw;
    height: 3.8vw;
  }
}
@media screen and (max-width: 900px) {
  .select-statistics select {
    width: 22.24vw;
    height: 4.7vw;
  }
}
@media screen and (max-width: 720px) {
  .select-statistics select {
    width: 26.24vw;
    height: 5.6vw;
  }
}
@media screen and (max-width: 680px) {
  .select-statistics select {
    width: 79vw !important;
    height: 6.6vw !important;
    /* height: 5.4vw !important; */
  }
}
/* @media screen and (max-width: 620px) {
  .select-statistics select {
    width: 30.24vw;
    height: 6.6vw;
  }
} */
@media screen and (max-width: 480px) {
  .select-statistics select {
    width: 70.24vw !important;
    height: 7.6vw !important;
    float: right;
  }
}
@media screen and (max-width: 430px) {
  .select-statistics select {
    width: 65.24vw !important;
    height: 8.6vw !important;
    float: right;
  }
}
@media screen and (max-width: 370px) {
  .select-statistics select {
    width: 60.24vw !important;
    height: 9.4vw !important;
    float: right;
  }
}
@media screen and (max-width: 330px) {
  .select-statistics select {
    width: 64.24vw !important;
    height: 10.4vw !important;
    float: right;
  }
}
</style>
<style scoped lang="scss">
.player-team {
  display: flex;
  align-items: center;
}
.filter-item {
  vertical-align: middle;
  margin: 5px;
  // background: greenyellow;
  flex-grow: 0;
  width: 420px;
  font-size: 15px;
  margin-top: 8px;
  color: #808285;
  @media screen and (max-width: 1700px) {
    margin-top: 20px;
  }
  @media screen and (max-width: 1400px) {
    width: 520px;
  }
  @media screen and (max-width: 1200px) {
    width: 620px;
  }
  @media screen and (max-width: 1050px) {
    width: 720px;
  }
  @media screen and (max-width: 900px) {
    width: 820px;
    margin-top: 35px;
  }
  @media screen and (max-width: 830px) {
    width: 920px;
    margin-top: 30px;
  }
  @media screen and (max-width: 768px) {
    width: 1000px;
  }
  @media screen and (max-width: 730px) {
    width: 1200px;
  }
  @media screen and (max-width: 700px) {
    width: 1300px;
  }
  @media screen and (max-width: 680px) {
    display: none;
  }
}
.select-statistics {
  width: auto;
  margin-top: 0.314vw;
}
@media screen and (max-width: 680px) {
  .select-statistics {
    margin-top: 0.514vw !important;
  }
}
.cont-selector {
  width: 100%;
  height: 3vw;
  // background: red;
  display: inline-flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  margin-bottom: 0.1vw;
  margin-top: -30px;

  @media screen and (max-width: 900px) {
    margin-bottom: 4.87vw;
  }
  @media screen and (max-width: 680px) {
    margin-top: 5px;
  }
  @media screen and (max-width: 650px) {
    margin-bottom: 6.87vw;
  }

  @media screen and (max-width: 500px) {
    margin-bottom: 16.87vw;
  }
  &__div-Selector {
    width: 88%;
    height: 2px;

    border-bottom: 1px dotted gray;
    @media screen and (max-width: 1700px) {
      margin-top: 1.044vw;
    }
    @media screen and (max-width: 1350px) {
      margin-top: 1.444vw;
    }
    @media screen and (max-width: 1100px) {
      margin-top: 1.944vw;
    }
    @media screen and (max-width: 900px) {
      margin-top: 3.244vw;
    }
    @media screen and (max-width: 680px) {
      display: none;
    }
    @media screen and (max-width: 620px) {
      margin-top: 5.244vw;
    }
    @media screen and (max-width: 500px) {
      display: none;
    }
  }
  &__cont-select-tournament {
    width: auto;
    height: 2.1vw;
    margin-left: 8px;
    display: inline-flex;
    justify-content: space-between;
    @media screen and (max-width: 680px) {
      width: 94%;
      margin: 0 auto;
      margin-top: 15px;
      justify-content: center;
      height: 6.1vw;
    }
    // @media screen and (max-width: 500px) {
    //   width: 100%;
    // }
    &__label {
      width: 4.7vw;
      font-family: 'Roboto-Regular';
      font-size: 0.967vw;
      height: 1.9vw;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.9vw;
      margin-top: 0.33vw;
      letter-spacing: -0.13px;
      text-align: center;
      color: #3c444b;
      @media screen and (max-width: 1700px) {
        height: 2.4vw;
        line-height: 2.4vw;
      }
      @media screen and (max-width: 1350px) {
        height: 3.1vw;
        line-height: 3.1vw;
        font-size: 1.37vw;
        width: 7.7vw;
      }
      @media screen and (max-width: 1100px) {
        height: 3.8vw;
        line-height: 3.8vw;
        font-size: 1.77vw;
        width: 8.5vw;
      }
      @media screen and (max-width: 900px) {
        height: 4.7vw;
        line-height: 4.7vw;
        font-size: 2.17vw;
        width: 10.5vw;
      }
      @media screen and (max-width: 720px) {
        height: 5.6vw;
        line-height: 5.6vw;
        font-size: 2.17vw;
        width: 10.5vw;
      }
      @media screen and (max-width: 680px) {
        height: 6.6vw;
        line-height: 6.6vw;
        font-size: 3vw;
        width: 13.5vw;
      }
      @media screen and (max-width: 620px) {
        height: 6.6vw;
        line-height: 6.6vw;
        font-size: 3.17vw;
        width: 13.5vw;
      }
      @media screen and (max-width: 480px) {
        height: 10.6vw;
        line-height: 8.6vw;
        font-size: 3.7vw;
        width: 20.5vw;
      }
      @media screen and (max-width: 430px) {
        font-size: 4.5vw;
      }
      @media screen and (max-width: 370px) {
        font-size: 4.5vw;
        line-height: 10.7vw;
      }
    }
  }
}
.first-element {
  margin-right: 1.053vw;
  @media screen and (max-width: 1120px) {
    margin-right: 0vw;
  }
}
.second-element {
  margin-left: 1.053vw;
  @media screen and (max-width: 1120px) {
    margin-left: 0vw;
  }
}
.cont-summaryVideostrengths {
  display: inline-flex;
  width: 100%;
  height: auto;
  margin-top: 15px;
  @media screen and (max-width: 1120px) {
    display: inline-block;
  }
  @media screen and (max-width: 680px) {
    margin-top: 10px;
  }
  @media screen and (max-width: 650px) {
    margin-top: 0px;
  }
  @media screen and (max-width: 500px) {
    margin-top: -45px;
  }
  @media screen and (max-width: 480px) {
    margin-top: -35px;
  }
  @media screen and (max-width: 430px) {
    margin-top: -28px;
  }
  @media screen and (max-width: 400px) {
    margin-top: -20px;
  }
  @media screen and (max-width: 370px) {
    margin-top: -15px;
  }
}
.summaryVideostrengths {
  width: 100%;
  height: auto;
  margin-bottom: 4.211vw;
  display: inline-flex;
  @media screen and (max-width: 1120px) {
    display: inline-block;
  }
  &__video {
    width: 100%;
    height: 33.668vw;
    margin-left: 0.751vw;
    margin-right: 0.751vw;
    margin: 0 auto;
    margin-top: 1.263vw;
    margin-bottom: 2.526vw;
    @media screen and (max-width: 1750px) {
      height: 36.244vw;
    }
    @media screen and (max-width: 1400px) {
      height: 35.668vw;
    }
    @media screen and (max-width: 1350px) {
      height: 36.668vw;
    }
    @media screen and (max-width: 1300px) {
      height: 37.168vw;
    }
    @media screen and (max-width: 1250px) {
      height: 37.668vw;
    }
    @media screen and (max-width: 1200px) {
      height: 38.624vw;
    }
    @media screen and (max-width: 1120px) {
      height: 69.668vw;
    }
    @media screen and (max-width: 1028px) {
      height: 74.668vw;
    }
    @media screen and (max-width: 1010px) {
      height: 76.668vw;
    }
    @media screen and (max-width: 800px) {
      height: 78.668vw;
    }
    @media screen and (max-width: 800px) {
      height: 79.668vw;
    }
    @media screen and (max-width: 760px) {
      height: 80.668vw;
    }

    @media screen and (max-width: 670px) {
      height: 83.668vw;
    }
    @media screen and (max-width: 640px) {
      height: 84.668vw;
    }
    @media screen and (max-width: 580px) {
      height: 87.668vw;
    }
    @media screen and (max-width: 535px) {
      height: 89.668vw;
    }
    @media screen and (max-width: 500px) {
      height: 100.668vw;
    }
    @media screen and (max-width: 460px) {
      height: 103.668vw;
    }
    @media screen and (max-width: 430px) {
      height: 106.668vw;
    }
    @media screen and (max-width: 400px) {
      height: 110.668vw;
    }
    @media screen and (max-width: 370px) {
      height: 117.668vw;
    }
    @media screen and (max-width: 340px) {
      height: 121.668vw;
    }
    @media screen and (max-width: 320px) {
      height: 125.668vw;
    }
  }
  &__strengths {
    width: 100%;
    color: white;
    height: auto;
    margin-left: 0.751vw;
    margin-right: 0.751vw;
    margin-top: 1.263vw;
    margin-bottom: 2.526vw;
    @media screen and (max-width: 1120px) {
      margin: 0 auto;
    }
  }
}
.summaryGenLast {
  width: 100%;
  height: auto;
  margin-bottom: 4.211vw;
  display: inline-flex;
  @media screen and (max-width: 1120px) {
    display: inline-block;
    margin-top: 6.211vw;
  }
  &__general {
    width: 100%;
    height: auto;
    margin-left: 0.751vw;
    margin-right: 0.751vw;
    margin-top: 1.263vw;
    margin-bottom: 2.526vw;
    @media screen and (max-width: 1120px) {
      margin: 0 auto;
      padding-left: 1.951vw;
      padding-right: 1.951vw;
      margin-top: 1.263vw;
      margin-bottom: 2.526vw;
    }
    @media screen and (max-width: 500px) {
      margin: 0 auto;
      padding-left: 1.2vw;
      padding-right: 1.2vw;
      margin-top: 1.263vw;
      margin-bottom: 2.526vw;
    }
  }
  &__lastgame {
    width: 100%;
    color: white;
    height: auto;
    margin-left: 0.751vw;
    margin-right: 0.751vw;
    margin-top: 1.263vw;
    margin-bottom: 2.526vw;
    @media screen and (max-width: 1120px) {
      margin: 0 auto;
      padding-left: 1.951vw;
      padding-right: 1.951vw;
      margin-top: 1.263vw;
      margin-bottom: 2.526vw;
    }
    @media screen and (max-width: 500px) {
      margin: 0 auto;
      padding-left: 1.2vw;
      padding-right: 1.2vw;
      margin-top: 1.263vw;
      margin-bottom: 2.526vw;
    }
  }
}
</style>
